import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AuthService } from '../../core/auth.service';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { InternalVehicleStatus } from '../../models/vehicle-statuses.model';
import { UserVehicleGroup } from '../../models/vehicle-types.model';
import { of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class FilterInputService {
  private urlGroups =
    environment.baseUrl +
    environment.api +
    'vehicles_groups' +
    environment.surfix;
  private urlVehiclesFilters =
    environment.baseUrl + environment.api + 'users/vehicles_filter_newer';

  private filterStatuses = [
    {
      label: 'vehicles.filter.status.unavailable',
      value: InternalVehicleStatus.UNAVAILABLE,
      icon: 'fa fa-wifi',
      order: 10,
      color: 'red',
    },
    // {
    //   label: 'vehicles.filter.status.power_warning',
    //   value: InternalVehicleStatus.POWER_WARNING,
    //   icon: 'fa fa-battery-half',
    //   order: 20,
    //   color: 'red',
    // },
    {
      label: 'vehicles.filter.status.no_data',
      value: InternalVehicleStatus.NO_DATA,
      icon: 'fa fa-ban',
      order: 20,
      color: 'red',
    },
    {
      label: 'vehicles.filter.status.power_critical',
      value: InternalVehicleStatus.POWER_CRITICAL,
      icon: 'fa fa-battery-empty',
      order: 30,
      color: 'yellow',
    },
    {
      label: 'vehicles.filter.status.ok',
      value: InternalVehicleStatus.OK,
      icon: 'fa fa-check',
      order: 40,
      color: 'black',
    },
    {
      label: 'vehicles.filter.status.disconnected',
      value: InternalVehicleStatus.DISCONNECTED,
      icon: 'fa fa-exclamation-triangle',
      order: 50,
      color: 'black',
    },
  ];

  private alarmStatuses = [
    {
      label: 'vehicles.filter.status.droplet',
      value: InternalVehicleStatus.DROPLET,
      image: 'assets/interface/droplet-solid.svg',
      order: 10,
      color: 'red',
    },
    {
      label: 'vehicles.filter.status.temperature',
      value: InternalVehicleStatus.TEMPERATURE,
      image: 'assets/interface/temperature-half-solid-red.svg',
      order: 20,
      color: 'red',
    },
    {
      label: 'vehicles.filter.status.station',
      value: InternalVehicleStatus.STATION,
      image: 'assets/interface/power_off_icon.svg',
      order: 30,
      color: 'red',
    },
  ];

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private translateService: TranslateService
  ) {}

  async ngOnInit() {
    await this.translateService.get('admin-panel').toPromise().then();
  }

  updateVehiclesFilter(vehiclesFilter) {
    if (this.authService.isDSLocateUser()) {
      localStorage.setItem('filterState', JSON.stringify(vehiclesFilter));
      return of(true);
    } else {
      return this.http.post(this.urlVehiclesFilters, vehiclesFilter, {
        headers: this.authService.getJwtAuthHeaders(),
      });
    }
  }

  getUserGroups() {
    return this.http
      .get(this.urlGroups, {
        headers: this.authService.getJwtAuthHeaders(),
      })
      .pipe(
        map((response: UserVehicleGroup[]) =>
          response.map((group) => {
            const val = new UserVehicleGroup(group);
            return new Object({ label: group['name'], value: val });
          })
        )
      );
  }

  getFilterStatuses() {
    return this.filterStatuses.map((filter) => {
      filter.label = this.translateService.instant(filter.label);
      return filter;
    });
  }

  getAlarmStatuses() {
    return this.alarmStatuses.map((filter) => {
      filter.label = this.translateService.instant(filter.label);
      return filter;
    });
  }
}
